import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from 'torqcloud-ui'

import { playground } from '@/constants/routing'
import useOrganizationAuditLogAccess from '@/hooks/useOrganizationAuditLogAccess'

export default function OrganizationAuditLogGuard({ children }: { children: ReactNode }) {
  const { hasMetadata } = useAuth()
  const { canViewOrganizationAuditLog } = useOrganizationAuditLogAccess()

  if (!hasMetadata) {
    return null
  }

  if (!canViewOrganizationAuditLog) {
    return <Navigate to={playground()} replace />
  }

  return <>{children}</>
}
